import { Box, Flex } from "@mantine/core";
import { useToggle } from "@mantine/hooks";
import { Outlet, useLocation } from "react-router-dom";

import { Footer, Header, MobileHeader, MobileNav, Navbar } from "./components";
import { DEFAULT_PAGE_LABEL, MENU_ITEMS } from "./constants";

export default function DashboardLayout() {
  const { pathname } = useLocation();
  const [value, toggle] = useToggle();
  const activeItem = MENU_ITEMS.find((item) => pathname.includes(item.path));

  return (
    <Flex h="100vh" direction="column" p="md">
      <Box hiddenFrom="md">
        <MobileHeader />
      </Box>

      <Box visibleFrom="md">
        <Header collapsed={value} title={activeItem?.label ?? DEFAULT_PAGE_LABEL} onToggle={toggle} />
      </Box>

      <Flex flex={1} gap="md" py="md" mih={0}>
        <Box visibleFrom="md">
          <Navbar collapsed={value} />
        </Box>

        <Box
          component="main"
          flex={1}
          h="100%"
          p="md"
          bg="neutral.2"
          bdrs="lg"
          style={{
            overflowY: "auto",
          }}
        >
          <Outlet />
        </Box>
      </Flex>

      <Box hiddenFrom="md">
        <MobileNav />
      </Box>

      <Box visibleFrom="md">
        <Footer collapsed={value} />
      </Box>
    </Flex>
  );
}
